import React from "react";

export default function LeftArrowPagination({ onClick,strokeColor = "#667085", }) {
  return (
    <button onClick={onClick} className="leftArrowPagination">
      <svg width="7.5" height="15" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2L2 14L14 26" stroke={strokeColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      </svg> 
    </button>
  );
}
